import { CaretRight, WhatsappIcon } from "@/components/shared/icons";
import { Typography } from "@/components/shared/typography";
import { Card, CardContent, View } from "@/components/ui";
import { generateBookingChatSalesMessage, onChatSales } from "@/lib/chat-sales";
import type { ServiceName } from "@/types/service";

export const HelpCard = ({
  name,
  subTitle,
}: {
  name: ServiceName;
  subTitle?: string;
}) => {
  return (
    <Card
      className="mx-4 my-2 cursor-pointer"
      onClick={() => onChatSales(true, generateBookingChatSalesMessage(name))}
    >
      <CardContent>
        <View className="flex flex-row items-center justify-between">
          <View className="flex flex-row items-center gap-4">
            <WhatsappIcon className="size-8 text-success" />
            <View className="self-start">
              <Typography variant="body-lg">
                Can't find what you need?
              </Typography>
              <Typography variant="body-sm" color="foreground-intermediate">
                {subTitle || "Let us match you with the perfect groomers!"}
              </Typography>
            </View>
          </View>

          <CaretRight />
        </View>
      </CardContent>
    </Card>
  );
};
